import Highcharts from 'highcharts'

// Set some global options for Highcharts
function shadeColor2(color, percent) {
  var f = parseInt(color.slice(1), 16),
    t = percent < 0 ? 0 : 255,
    p = percent < 0 ? percent * -1 : percent,
    R = f >> 16,
    G = (f >> 8) & 0x00ff,
    B = f & 0x0000ff
  return (
    '#' +
    (
      0x1000000 +
      (Math.round((t - R) * p) + R) * 0x10000 +
      (Math.round((t - G) * p) + G) * 0x100 +
      (Math.round((t - B) * p) + B)
    )
      .toString(16)
      .slice(1)
  )
}

function shadeRGBColor(color, percent) {
  var f = color.split(','),
    t = percent < 0 ? 0 : 255,
    p = percent < 0 ? percent * -1 : percent,
    R = parseInt(f[0].slice(4)),
    G = parseInt(f[1]),
    B = parseInt(f[2])
  return (
    'rgb(' +
    (Math.round((t - R) * p) + R) +
    ',' +
    (Math.round((t - G) * p) + G) +
    ',' +
    (Math.round((t - B) * p) + B) +
    ')'
  )
}

function shade(color, percent) {
  if (color.length > 7) return shadeRGBColor(color, percent)
  return shadeColor2(color, percent)
}

let color1 = '#344AF9'
let color2 = '#9941F1'
let color4 = '#FF00E5'
let color5 = '#47EBCF'
let color6 = '#BD15F3'
let color7 = shade(color1, 0.6)
let color8 = shade(color2, 0.6)
let color9 = shade(color4, 0.6)
let color10 = shade(color5, 0.6)
let color11 = shade(color6, 0.6)
var color12 = shade(color10, 0.6)
let color13 = '#051061'
let color14 = '#9295AA'
let color15 = '#55B0C4'

/**
 * @description Set some global options for Highcharts.
 * Can be overridden in each chart.
 * Can be imported using:
 * import Highcharts from 'utils/highcharts.js'
 */
Highcharts.setOptions({
  colors: [
    color2,
    color4,
    color1,
    color5,
    color7,
    color10,
    color1,
    color6,
    color8,
    color11,
    color9,
    color12,
    color13,
    color14,
    color15,
  ],

  credits: {
    enabled: false,
  },

  exporting: {
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },

  chart: {
    backgroundColor: null,
    spacing: 0,
    style: {
      fontFamily: '"Open Sans", Helvetica, Arial, sans-serif',
      fontSize: '.825rem',
      color: '#4E4E4E',
    },
    zooming: {
      mouseWheel: false,
    },
  },

  title: {
    align: 'center',
    style: {
      font: '700 1rem "Open Sans", Helvetica, Arial, sans-serif',
    },
  },

  subtitle: {
    style: {
      color: '#051061',
    },
  },

  legend: {
    align: 'right',
    verticalAlign: 'bottom',
    borderColor: '#ccc',
    padding: 12,
    borderWidth: 1,
    itemStyle: {
      fontSize: '.75rem',
      color: '#4E4E4E',
    },
    itemHoverStyle: {
      color: '#4E4E4E',
    },
  },

  // Chart Styles
  xAxis: {
    title: {
      style: {
        color: '#4E4E4E',
        fontWeight: '700',
        fontSize: '.825rem',
      },
    },
    labels: {
      style: {
        color: '#4E4E4E',
      },
    },
  },

  yAxis: {
    title: {
      style: {
        color: '#4E4E4E',
        fontWeight: '700',
        fontSize: '.825rem',
      },
    },
    labels: {
      style: {
        color: '#4E4E4E',
      },
    },
  },

  tooltip: {
    backgroundColor: '#ffffff',
    borderWidth: 0,
    borderRadius: 5,
    padding: 12,
  },

  // Specific chart types
  plotOptions: {
    series: {
      marker: {
        enabled: false,
        symbol: 'circle',
        radius: 4,
        lineWidth: 2,
        fillColor: '#fff',
        lineColor: undefined,
      },
    },

    pie: {
      showInLegend: true,
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
        format: '<strong>{point.name}</strong>: {point.percentage:.1f} %',
        style: {
          color:
            (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
        },
      },
    },

    column: {
      pointPadding: 0,
      groupPadding: 0.05,
      maxPointWidth: 100,
    },
  },
})

// export Highcharts with global options set
export default Highcharts
